export default __webpack_public_path__ + "static/media/instagramIconWhite.e0e0eb0f.svg";